import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { ALLOCATE_VOUCHER, ALLOCATE_VOUCHER_SUCCESS, ALLOCATE_VOUCHER_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* allocateVoucher({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/create-voucher-draft`,
      method: 'POST',
      data: payload.data,
      // isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: ALLOCATE_VOUCHER_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: ALLOCATE_VOUCHER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: ALLOCATE_VOUCHER_ERROR, payload: error });
  }
}

export function* watchAllocateVoucher() {
  yield takeEvery(ALLOCATE_VOUCHER, allocateVoucher);
}

function* allocateVoucherSaga() {
  yield all([fork(watchAllocateVoucher)]);
}

export default allocateVoucherSaga;
